const styles = (theme) => ({
  paper: {
    padding: { xs: "20px", md: "30px" },
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: 1,
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifyContent: "space-between",
    width: "100%",
  },
  headerTitleBox: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  title: { fontWeight: "bold", fontSize: "20px" },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: "13px",
    maxWidth: "100%",
  },
  counterChip: {
    fontWeight: "bold",
    color: theme.palette.white.main,
    backgroundColor: "chip.main.arquive",
  },
  loadingContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    p: 4,
  },
  treeContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  accordion: {
    borderRadius: "12px !important",
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "none",
    "&:before": { display: "none" },
    overflow: "hidden",
  },
  accordionSummary: {
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
      margin: "8px 0",
    },
  },
  accordionDetails: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    pt: 0,
    pb: 1.5,
  },
  leafRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "12px",
    p: 1.5,
    pl: 2,
  },
  rowContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    pr: 1,
  },
  rowLabel: { display: "flex", alignItems: "center", gap: 1, minWidth: 0 },
  rowText: {
    fontWeight: 600,
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  childRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    pl: 2,
    py: 0.75,
    ml: "22px",
    borderLeft: `2px solid ${theme.palette.divider}`,
  },
  rowTextChild: {
    fontSize: "13px",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  chipDisabled: {
    fontWeight: "bold",
    fontSize: "10px",
    height: "20px",
    backgroundColor: theme.palette.chip.background.critical,
    color: theme.palette.chip.colorText.critical,
  },
});

export default styles;
